export enum MessageLevel {
	NOTICE = 'NOTICE',

	INFO = 'INFO'
}
